<template>
  <d-modal @close="handleClose">
    <slot name="modalContent">
      <d-modal-header>
        <slot name="headerContent">
          <d-modal-title>
            <slot name="titleContent" />
          </d-modal-title>
        </slot>
      </d-modal-header>

      <d-modal-body>
        <slot name="bodyContent" />
      </d-modal-body>

      <d-modal-footer v-if="showFooter">
        <slot name="footerContent" />
      </d-modal-footer>
    </slot>
  </d-modal>
</template>

<script>
export default {
  name: 'modal',
  props: {
    modal: {
      required: true,
    },
    showFooter: Boolean,
  },
  data () {
    return {
      d_modal: this.modal,
    };
  },
  mounted () {
    let body = document.querySelector('body');
    body.classList.add('modal-open');
  },
  beforeDestroy () {
    let body = document.querySelector('body');
    body.classList.remove('modal-open');
  },
  methods: {
    handleClose () {
      this.d_modal.close();
    },
  },
}
</script>
